import React from "react";
import { Hero, Section } from "../components/Page/Page.js";
import LeadForm from "../components/Page/LeadForm.js";
import { BOOKING_URL, WHATSAPP } from "../config.js";

export default function BookScreen() {
  return (
    <>
      <Hero title="Book a discovery call" text="30 minutes with a climate practitioner. No obligation." />
      {BOOKING_URL && (
        <Section title="Pick a time">
          <iframe title="Book a call" src={BOOKING_URL} style={{ width: "100%", height: 700, border: 0 }} />
          <p style={{ marginTop: 12 }}><a href={BOOKING_URL} target="_blank" rel="noreferrer">Open the calendar in a new tab</a></p>
        </Section>
      )}
      <Section title={BOOKING_URL ? "Or tell us about your needs" : "Tell us about your needs"} alt={!!BOOKING_URL}>
        <LeadForm
          kind="discovery-call"
          button="Request a call"
          fields={[
            ["name", "Name"],
            ["email", "Work email", "email"],
            ["company", "Company"],
            ["role", "I am a…", "select:Company buying offsets,Project developer selling credits,Investor or partner,Other"],
            ["message", "What would you like to discuss?", "textarea", false],
          ]}
        />
        {WHATSAPP && <p style={{ marginTop: 20 }}>Prefer WhatsApp? <a href={`https://wa.me/${WHATSAPP}`}>Message us</a></p>}
      </Section>
    </>
  );
}
